import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../components/layouts/dashboardLayout";
import Loader from "../../components/loader/loader";
import { BASE_URL } from "../../config/endPoint";
import { httpDelete, httpGet } from "../../utils/api";

function Brands() {
  const [search, setSearch] = useState("");
  const [countries, setCountries] = useState([]);
  const [filtercountries, setFiltercountries] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [brandId, setBrandId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setBrandId(id);
    setShow(true);
  };

  const getBrands = async () => {
    await httpGet(`${BASE_URL}/brand/list`)
      .then((res) => {
        if (res?.data?.status) {
          console.log("pppp",res.data.response);
          const grouped = groupBrandsByCategory(res.data.response);
          setBrandList(grouped);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };
  const groupBrandsByCategory = (brands) => {
      const map = {};

      brands.forEach((item) => {
        const catId = item?.cateId?._id;
        const catName = item?.cateId?.name;

        if (!catId) return;

        if (!map[catId]) {
          map[catId] = {
            categoryId: catId,
            categoryName: catName,
            brandCount: 0,
          };
        }

        map[catId].brandCount += 1;
      });

      return Object.values(map);
    };


  useEffect(() => {
    getBrands();
  }, []);

 const colunms = [
  {
    name: (
      <h6>
        <b>Category Name</b>
      </h6>
    ),
    selector: (row) => row.categoryName,
    sortable: true,
  },
  {
    name: (
      <h6>
        <b>No. of Brands</b>
      </h6>
    ),
    selector: (row) => row.brandCount,
    sortable: true,
  },
  {
    name: <b>Action</b>,
    cell: (row) => (
      <div style={{ display: "flex", gap: "10px" }}>
        <button
          onClick={() => navigate(`/category-brands/${row.categoryId}`)}
          style={{ border: "none", background: "transparent" }}
        >
          <i className="fa-solid fa-pen" style={{ color: "blue" }}></i>
        </button>

        <button
          onClick={() => handleShow(row.categoryId)}
          style={{ border: "none", background: "transparent" }}
        >
          <i className="fas fa-trash" style={{ color: "red" }}></i>
        </button>
      </div>
    ),
  },
];


  const customStyles = {
    tableWrapper: {
      style: {
        display: "table",
        paddingLeft: "16px",
      },
    },
    rows: {
      style: {
        minHeight: "72px", // override the row height
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
      },
    },
  };

  const deleteBrand = async () => {
    setIsLoadingDelete(true);
    await httpDelete(`${BASE_URL}/brand/${brandId}`)
      .then((res) => {
        console.log(res);
        if (res?.data?.status) {
          setBrandId("");
          getBrands();
          toast.success(res?.data?.message);
          setShow(false);
          setIsLoadingDelete(false);
        }
      })
      .catch((err) => {
        setIsLoadingDelete(false);
        console.log(err);
      });
  };

  const filteredItems = brandList.filter(
  (item) =>
    item.categoryName &&
    item.categoryName.toLowerCase().includes(search.toLowerCase())
);


  const actions = (
    <Button
      className="add-btn"
      type="button"
      onClick={() => navigate("/addbrand")}
    >
      Add Brand
    </Button>
  );

  return (
    <DashboardLayout>
      <div className="table-outer ">
        <DataTable
          title="Brands"
          columns={colunms}
          data={filteredItems}
          pagination
          fixedHeader
          actions={actions}
          customStyles={customStyles}
          progressPending={isLoading}
          // fixedHeaderScrollHeight="500px"
          selectableRowsHighlight
          highlightOnHover
          subHeader
          subHeaderComponent={
            <>
              <input
                type="text"
                placeholder="Search here"
                className="  form-control"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </>
          }
        />
        {isLoadingDelete && <Loader />}
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Brand</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure, you want to delete this record?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              No
            </Button>
            <Button variant="primary" onClick={deleteBrand}>
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </DashboardLayout>
  );
}

export default Brands;
